import { Injectable } from '@angular/core';
import { WorkorderService } from "./workorder.service";
import { DatePipe } from "@angular/common";

@Injectable()

export class ReportService {

  data: any = null;
  active = false;

  constructor(
      public datePipe: DatePipe,
      public workorderService: WorkorderService
  ) {}

  public getData(){
    console.log('ReportService.getData');
    return this.data;
  }

  public setData(data){
    console.log('ReportService.setData', data);
    this.active = true;
    this.data = data;
  }

  public clearData(){
    console.log('ReportService.clearData');
    this.active = false;
    this.data = null;
  }

  public isActive(){
    return this.active;
  }

  public setActive(value){
    console.log('ReportService.setActive: ' + value);
    this.active = value;
  }

  public save(){
    console.log('reportService.save');
    return new Promise((resolve, reject) => {
      if(this.data === null){
        resolve();
      }
      // Set list title
      this.data.list_title = this.getListTitle();
      this.data.list_subtitle = this.getListSubtitle();
      // Save
      this.workorderService.setWorkorder(this.data).then(() => {
        resolve();
      }).catch(() => {
        reject();
      })
    });
  }

  private getListTitle(){
    let list_title = '';
    if(this.data.workorder_nr) list_title += '[' + this.data.workorder_nr + '] ';
    if(this.data.customers.client.company){
      list_title += this.data.customers.client.company + ' ';
    } else {
      if(this.data.customers.client.firstname) list_title += this.data.customers.client.firstname + ' ';
      if(this.data.customers.client.lastname) list_title += this.data.customers.client.lastname;
    }
    if(this.data._selected_units && this.data._selected_units.length > 0 && this.data._selected_units[0].list_title){
      let unit = this.data._selected_units[0];
      if(list_title){
        list_title += ' - ';
      }
      list_title += unit.list_title;
    }
    list_title = list_title.trim();
    if(!list_title) list_title = 'Onbekende werkorder';
    return list_title;
  }

  private getListSubtitle(){
    let list_subtitle = '';
    if(this.data.time_planned && this.data.time_planned > 0){
      let time_planned = new Date(this.data.time_planned * 1000);
      let time_planned_string = this.datePipe.transform(time_planned, 'dd-MM-y HH:mm');
      if(this.datePipe.transform(time_planned, 'HH:mm') == '00:00'){
        time_planned_string = this.datePipe.transform(time_planned, 'dd-MM-y');
      }
      list_subtitle += time_planned_string + ' - ';
    }
    if(this.data.location.street) list_subtitle += this.data.location.street + ' ';
    if(this.data.location.number) list_subtitle += this.data.location.number;
    if(this.data.location.letter) list_subtitle += this.data.location.letter;
    if(this.data.location.zipcode){
      if(list_subtitle) list_subtitle += ', ';
      list_subtitle += this.data.location.zipcode;
    }
    if(this.data.location.city) {
      if(list_subtitle) list_subtitle += ', ';
      list_subtitle += this.data.location.city;
    }
    if(this.data._selected_units && this.data._selected_units.length > 0 && this.data._selected_units[0].list_subtitle){
      let unit = this.data._selected_units[0];
      if(list_subtitle){
        list_subtitle += ' - ';
      }
      list_subtitle += unit.list_subtitle;
    }
    list_subtitle = list_subtitle.trim();
    if(!list_subtitle) list_subtitle = 'Onbekende locatie';
    return list_subtitle;
  }

}



// WEBPACK FOOTER //
// ./src/services/report.service.ts